function passengerLabel(passenger) {
  if (!passenger || (!passenger.firstName && !passenger.lastName)) {
    return passenger.phoneNumber || '';
  }
  return `${passenger.firstName || ''} ${passenger.lastName || ''}`.trim();
}

export default passengerLabel;
